<dx-popup
    #communityVendorHistoryPopup
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="45%"
    [title]="title"
    [showCloseButton]="true"
    [showTitle]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onShown()"
    (onHidden)="onHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <app-view-history
                    [historySource]="historySource"
                    [columnDef]="historyColumns"
                    [communityId]="communityId"
                ></app-view-history>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="button-container">
                    <div>
                        <dx-button
                            type="default"
                            text="Close"
                            hint="Close"
                            [icon]="iconClose"
                            (onClick)="onHidden()"
                        ></dx-button>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
